import { apiPadron } from "../Utils/RutasApi";
import { trackPromise } from "react-promise-tracker";
import { SolicitudConsultaPadron } from "../Contenedores/Padron/SolicitudConsultaPadron";
import Http from "./Http";
import ResultadoConsultaPadron from "../Contenedores/Padron/ResultadoConsultaPadron";
import Identificacion from "../Contenedores/Comun/Identificacion";

export async function ConsultaPadron(parametro: SolicitudConsultaPadron) {
  const url = apiPadron.ConsultaPadron;
  let resultado = new ResultadoConsultaPadron();

  let respuesta = await trackPromise(Http.post<any>(url, parametro));

  resultado.EsValido = respuesta.data.esValido;
  resultado.Errores = respuesta.data.errores;
  resultado.Mensaje = respuesta.data.Mensaje;
  resultado.Personas = respuesta.data.personas;
  return resultado;
}

export async function ObtengaPersonaUnificada(identificacion: Identificacion) {
  var resultado = null;
  let url = apiPadron.ObtengaPersonaUnificada;
  resultado = await trackPromise(Http.post<any>(url, identificacion));
  return resultado.data;
}

const PadronServicio = {
  ConsultaPadron,
  ObtengaPersonaUnificada
};

export default PadronServicio;
